import boltNew from './views/bolt.js';
export default boltNew;
